











































import { Component, Prop, Vue } from 'vue-property-decorator';
import { app } from '@src/store/modules/app';
import AuthenticatedNav from '@classes/AuthenticatedNav';
import { currency } from '@filters/shared-filters';
import { HeaderStyle } from 'types/header';
import { InvestmentEntity } from 'types/investment-entity';
import { investmentEntity } from '@store/modules/investment-entity';
import MobileNavTemplate from '@components/header/navigation/mobile/mobile-nav-template.vue';
import MobileNavUserHeader from './mobile-nav-user-header.vue';
import NavigationLinkMobile from '@components/header/navigation/mobile/navigation-link-mobile.vue';
import NavInvestmentEntityList from '../nav-investment-entity-list.vue';
import { user } from '@store/modules/user';

@Component({
	components: {
		MobileNavUserHeader,
		MobileNavTemplate,
		NavigationLinkMobile,
		NavInvestmentEntityList
	}
})
export default class MobileNavAuth extends Vue {
	@Prop()
	private styles!: HeaderStyle;

	currency = currency;

	isInvestTabEnabled = true;

	private async handleLogout() {
		await app.revokeUserToken();
	}

	get investmentEntityObject(): InvestmentEntity {
		return investmentEntity.investmentEntityObject;
	}

	get investTabEnabled(): boolean {
		return !this.investmentEntityObject.isIraEntity && this.isInvestTabEnabled;
	}

	get nav(): AuthenticatedNav {
		return new AuthenticatedNav(user.user, investmentEntity.investmentEntityObject, this.investTabEnabled);
	}

	get referralAmount(): string {
		return user.invitationDetails?.invitationDetails.rewardPerInvite ?? '';
	}
}
